import { useState } from 'react';
export const useStudioUiState = ()=>{
    const [showAgreementSettings, setShowAgreementSettings] = useState(false);
    const [showPaymentSettings, setShowPaymentSettings] = useState(false);
    const [showTemplateVariablesSection, setShowTemplateVariablesSection] = useState(false);
    return {
        showAgreementSettings,
        setShowAgreementSettings,
        showPaymentSettings,
        setShowPaymentSettings,
        showTemplateVariablesSection,
        setShowTemplateVariablesSection
    };
};
